<template>
    <PublicLayout :title="category.name">
        <!--        <template v-if="category.cover_responsive_images" #header>-->
        <!--            <div class="relative mx-auto bg-gray-100 mt-20 md:mt-0">-->
        <!--                <ResponsiveImage-->
        <!--                    :images="category.cover_responsive_images"-->
        <!--                    :name="category.name"-->
        <!--                    class="w-full max-h-72 md:max-h-96 object-contain object-top max-w-7xl m-auto py-5" />-->
        <!--                &lt;!&ndash; <div class="absolute inset-0 bg-gray-700 opacity-60 rounded-md"></div> &ndash;&gt;-->
        <!--                &lt;!&ndash; <div class="prose max-w-full absolute inset-0 flex items-center justify-center">-->
        <!--                    <h1-->
        <!--                        class="text-secondary text-center shadow-black [text-shadow:_2px_2px_2px_var(&#45;&#45;tw-shadow-color)]">-->
        <!--                        {{ category.name }}-->
        <!--                    </h1>-->
        <!--                </div> &ndash;&gt;-->
        <!--            </div>-->
        <!--        </template>-->
        <template v-if="category.cover_responsive_images" #title>
            <div />
        </template>
        <div v-if="category?.description" class="prose max-w-full mb-10" v-html="category.description"></div>
        <div class="grid gap-4 grid-cols-1" :class="`md:grid-cols-${gridCols}`">
            <ProductCard
                v-for="(product, index) in products"
                :id="`product-${index}`"
                :key="index"
                :images="product.preview_responsive_images || product.cover_responsive_images"
                :name="product.name"
                :description="product.abstract || product.description"
                :featured="product.featured"
                :url="route('products.show', {categories: category.full_slug, product: product.slug})">
            </ProductCard>
        </div>
    </PublicLayout>
</template>

<script setup>
import {ProductCard} from '@/Components/Frontend/Typography';
// import {ResponsiveImage} from '@/Components/Media';
import PublicLayout from '@/Layouts/PublicLayout.vue';

defineProps({
    category: {
        type: Object,
        required: true,
    },
    products: {
        type: Array,
        required: true,
    },
});

const gridCols = 1; // props.products.length !== 4 ? 3 : 2;
</script>
